import { render } from "./BugReportAdminPanel.vue?vue&type=template&id=7b0d76de&scoped=true"
import script from "./BugReportAdminPanel.vue?vue&type=script&lang=js"
export * from "./BugReportAdminPanel.vue?vue&type=script&lang=js"

import "./BugReportAdminPanel.vue?vue&type=style&index=0&id=7b0d76de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0d76de"]])

export default __exports__